import { DataSource } from '@angular/cdk/table';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { CollectionViewer } from '@angular/cdk/collections';
import { catchError, finalize } from 'rxjs/operators';
import { SalesHttpService } from '../_services/sales-http.service';

export class MemberSalesDataSource implements DataSource<any> {
	private MembSalesListSubject = new BehaviorSubject<any[]>([]);
	private loadingSubject = new BehaviorSubject<boolean>(false);

	public loading$ = this.loadingSubject.asObservable();

	empty = false;

	private countSubject = new BehaviorSubject<number>(0);
	public counter$ = this.countSubject.asObservable();

	private lastEvalKeySubject = new BehaviorSubject<number>(0);
	public lastEvalKey$ = this.lastEvalKeySubject.asObservable();

	constructor(private http: SalesHttpService) {}

	connect(collectionViewer: CollectionViewer): Observable<any[]> {
		return this.MembSalesListSubject.asObservable();
	}

	disconnect(collectionViewer: CollectionViewer): void {
		this.MembSalesListSubject.complete();
		this.loadingSubject.complete();
		this.countSubject.complete();
	}

	loadMembSalesList(qryParams: any) {
		this.empty = false;
		this.loadingSubject.next(true);
		this.http.getSaleByMember(qryParams).pipe(
			catchError(() => of([])),
			finalize(() => {
				this.loadingSubject.next(false);
			})
		)
		.subscribe(membSaleList => {
			this.loadingSubject.next(false);
			if (membSaleList.count === 0) {
				this.empty = true;
			}
			this.MembSalesListSubject.next(membSaleList.data);
			this.countSubject.next(Math.ceil(membSaleList.count));
			this.lastEvalKeySubject.next(membSaleList.LEK);
		});
	}
}
